import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

const CUTOFF_HOUR = 15; // 3 PM

/**
 * Returns true if it's after 3 PM in the partner's timezone.
 * Used to warn about potential escalation conflicts when scheduling holidays.
 */
export function isAfterCutoff(partnerTimezone: string): boolean {
  return dayjs().tz(partnerTimezone).hour() >= CUTOFF_HOUR;
}
